import {PropsWithChildren} from "react";
import {css} from "@panda/css";

import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

const COVER_HEIGHT = 80;
const COVER_WIDTH = 160;

interface IProps extends PropsWithChildren {
    address: string;
    imageUrl?: string;
    name: string;
}

export const ModalInvestmentLeadLayout = (props: IProps) => {
    const {address, children, imageUrl, name} = props;

    return (
        <div className={innerWrapStyle}>
            <div className={offerWrapperStyle}>
                {imageUrl && (
                    <div className={coverStyle}>
                        <Picture alt={name} className={pictureStyle} sources={[{height: COVER_HEIGHT, minWidthPX: 0, src: imageUrl, width: COVER_WIDTH}]} />
                    </div>
                )}

                <div className={offerInfoStyle}>
                    <Text as="h2" strong variant="headline_6">
                        {name}
                    </Text>

                    <Text color="var(--colors-gray-700)" variant="info_txt_1">
                        {address}
                    </Text>
                </div>
            </div>

            <div className={contentWrapperStyle}>{children}</div>
        </div>
    );
};

const contentWrapperStyle = css({
    mt: 4
});

const coverStyle = css({
    height: "8rem",
    width: "16rem",

    md: {
        minWidth: "16rem"
    }
});

const innerWrapStyle = css({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    maxHeight: "100vh",
    maxWidth: "100vw",
    overflow: "auto",
    position: "relative",
    px: 1.5,
    py: 3,

    md: {
        borderRadius: 1,
        height: "auto",
        p: 3,
        width: "55rem"
    }
});

const offerInfoStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    pr: 7,

    md: {
        pr: 4
    }
});

const offerWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,

    sm: {
        flexDirection: "row"
    }
});

const pictureStyle = css({
    justifyContent: "center",

    md: {
        mb: 3
    }
});
import {PropsWithChildren} from "react";
import {css} from "@panda/css";

import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

const COVER_HEIGHT = 80;
const COVER_WIDTH = 160;

interface IProps extends PropsWithChildren {
    address: string;
    imageUrl?: string;
    name: string;
}

export const ModalInvestmentLeadLayout = (props: IProps) => {
    const {address, children, imageUrl, name} = props;

    return (
        <div className={innerWrapStyle}>
            <div className={offerWrapperStyle}>
                {imageUrl && (
                    <div className={coverStyle}>
                        <Picture alt={name} className={pictureStyle} sources={[{height: COVER_HEIGHT, minWidthPX: 0, src: imageUrl, width: COVER_WIDTH}]} />
                    </div>
                )}

                <div className={offerInfoStyle}>
                    <Text as="h2" strong variant="headline_6">
                        {name}
                    </Text>

                    <Text color="var(--colors-gray-700)" variant="info_txt_1">
                        {address}
                    </Text>
                </div>
            </div>

            <div className={contentWrapperStyle}>{children}</div>
        </div>
    );
};

const contentWrapperStyle = css({
    mt: 4
});

const coverStyle = css({
    height: "8rem",
    width: "16rem",

    md: {
        minWidth: "16rem"
    }
});

const innerWrapStyle = css({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    maxHeight: "100vh",
    maxWidth: "100vw",
    overflow: "auto",
    position: "relative",
    px: 1.5,
    py: 3,

    md: {
        borderRadius: 1,
        height: "auto",
        p: 3,
        width: "55rem"
    }
});

const offerInfoStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    pr: 7,

    md: {
        pr: 4
    }
});

const offerWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,

    sm: {
        flexDirection: "row"
    }
});

const pictureStyle = css({
    justifyContent: "center",

    md: {
        mb: 3
    }
});
